import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        const handleScroll = () => {
            window.scrollTo(0, 0);
        };
        setTimeout(handleScroll, 300);
        return () => clearTimeout(handleScroll);
    }, [pathname]);

    return null;
}

export default ScrollToTop;